var map = {
	"./facebook-icon.svg": "1d67",
	"./instagram-icon.svg": "afef",
	"./odnoklassniki-icon.svg": "b16e",
	"./telegram-icon.svg": "8ea5",
	"./vk-icon.svg": "c8dd",
	"./yandex-zen-icon.svg": "5d29",
	"./youtube-icon.svg": "4295"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e55";